import React, { useEffect } from "react";
import DocWrapper from "../DocWrapper";
import docStyles from "../../../css/Docs/Docs.module.css";
import { Divider } from "@mui/material";
import CodeBlock from "../CodeBlock";
import { Link } from "react-router-dom";

const PendingStatements = () => {
  useEffect(() => {
    const el = document.getElementById("introduction");
    if (el) {
      el.scrollIntoView();
    }
  }, []);
 
  const curlSample = `
~~~curl
curl --location 'https://test.eqlfin.com/ services/statement?customerActivityId={{customerActivityId}}' 
--header 'Firebase-Env: env/core' 
--header 'Authorization: Basic {{BASIC_TOKEN}}
~~~
    `;

  return (
    <DocWrapper>
      <div className={docStyles.container}>
        <section id="introduction" className={docStyles.section}>
          <div className={docStyles.heading}>Introduction</div>
          <div className={docStyles.para}>
            This endpoint retrieves the pending statements for a specific customer
            identified by the customerActivityId parameter.
            <br />
            These statements are to be confirmed by the vendor and uploaded by
            the client.
          </div>
        </section>

        <br />
        <Divider sx={{ width: "100%" }} />

        <section id="fields" className={docStyles.section}>
          <div className={docStyles.heading}>Important Fields</div>
          <div className={docStyles.para}>
            To properly interact with the Offices, the following fields are
            important:
            <ul
              style={{
                padding: "0px 0px 5px 10px",
                margin: "5px 0px 5px 10px",
              }}
            >
              <li>customerActivityId</li>
            </ul>
          </div>
        </section>

        <br />
        <Divider sx={{ width: "100%" }} />

        <section id="request-example" className={docStyles.section}>
          <div className={docStyles.heading}>Request Example</div>
          <div className={docStyles.para}>
            Type: <b>GET</b>
          </div>

          <div className={docStyles.para}>
            To retrieve the pending statements for the specified office, you can
            use the following curl command:
            <CodeBlock codeMarkdown={curlSample} />
          </div>

          <div className={docStyles.infoBlock}>
            Please make sure to replace <b> customerActivityId </b> in the URL with the
            actual customerActivityId identifier. <br /> Additionally, replace{" "}
            <b> BASIC_TOKEN </b>
            in the Authorization header with the appropriate token for
            authentication.
          </div>

          <br />
          <Divider sx={{ width: "100%" }} />

          <section id="response" className={docStyles.section}>
            <div className={docStyles.heading}>Response</div>
            <div className={docStyles.para}>
              Upon a successful request, the API will respond with the following
              information:
            </div>

            {/* <div className={docStyles.subHeading}>201 - Created</div> */}
            <CodeBlock
              codeMarkdown={`
~~~json
{
    "status": true,
    "success": true,
    "code": 200,
    "statements": []
}

~~~
    `}
            />

            <div className={docStyles.para}>
              <b> statements (array): </b> An array containing the pending
              statements for the office. If no pending statements are available,
              the array will be empty.
            </div>
          </section>

          <Divider sx={{ width: "100%" }} />
          {/* <section id="error" className={docStyles.section}>
            <div className={docStyles.heading}>Error Responses</div>

            <div className={docStyles.para}>
              In case of errors during the API call, you may receive one of the
              following error responses:
              <ul
                style={{
                  padding: "0px 0px 5px 10px",
                  margin: "5px 0px 5px 10px",
                }}
              >
                <li>
                  <b>Unauthorized Error: </b> Occurs when the request lacks
                  valid authentication or authorization credentials.
                </li>
                <li>
                  <b> Server Error: </b> Indicates an unexpected error on the
                  server side, such as a database connection issue or an
                  unhandled exception.
                </li>
              </ul>
            </div>

            <div className={docStyles.subHeading}>400 - Bad Request</div>
            <CodeBlock
              codeMarkdown={`
    ~~~json
    {
        "message": "the field of type 'gst-office' must belong to the requesting office only",
        "success": false,
        "code": 400
    }
    ~~~
    `}
            />
          </section> */}
        </section>
      </div>
      <section className={docStyles.tableOfContentSection}>
        <div className={docStyles.tableOfContent}>
          <div className={docStyles.tocHeading}>Table of contents</div>
          <ul className={docStyles.tocList}>
            <li>
              <Link to="#introduction">Introduction</Link>
            </li>
            <li>
              <Link to="#fields">Important Fields</Link>
            </li>
            <li>
              <Link to="#request-example">Request Example</Link>
            </li>
            <li>
              <Link to="#response">Response</Link>
            </li>
            {/* <li>
              <Link to="#error">Error Response</Link>
            </li> */}
          </ul>
        </div>
      </section>
    </DocWrapper>
  );
};

export default PendingStatements;
